import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { useCurrentOrganization } from '@/modules/core/hooks';

export const COVERAGES_LIST_QUERY_KEY = 'COVERAGES_LIST';

export interface FormatedCoverage {
  id: string;
  name: string;
  code: string;
}

export default () => {
  const {
    observingOrganization: { path },
  } = useCurrentOrganization();

  const { isLoading, data } = useQuery(
    [COVERAGES_LIST_QUERY_KEY, path],
    () =>
      api.get(API_URL.COVERAGES, {
        params: {
          organization_path: path,
        },
      }),
    {
      enabled: !!path,
    }
  );
  const formatedData = useMemo(
    () =>
      data?.data.map((item) => ({
        id: `${item.id}`,
        name: item.name || '',
        code: item.code || '',
      })),
    [data]
  );

  return {
    data: formatedData,
    isLoading,
  };
};
